import type { EditorHandle } from "@shared/ui/Editor/ui";
import Editor from "@shared/ui/Editor/ui";
import {
  ChevronDown,
  Download,
  FileText,
  FileType,
  Loader2,
  X,
} from "lucide-react";
import type { RefObject } from "react";
import styles from "../styles.module.scss";

type BriefEditorSectionProps = {
  briefId: string;
  initialHtml: string;
  // isImporting: boolean;
  isDownloading: boolean;
  downloadLabel: string;
  downloadOpen: boolean;
  statusMessage: string | null;
  statusTone: "ok" | "err";
  editorRef: RefObject<EditorHandle | null>;
  fileInputRef: RefObject<HTMLInputElement | null>;
  downloadMenuRef: RefObject<HTMLDivElement | null>;
  onToggleDownload: () => void;
  // onUploadClick: () => void;
  // onFileChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onDownloadDoc: () => void;
  onDownloadPdf: () => void;
  onDismissStatus: () => void;
  onEditorChange: () => void;
  onMediaUploadStart: () => void;
  onMediaUploadComplete: () => void;
  onEditorReady: () => void;
};

export function BriefEditorSection({
  briefId,
  initialHtml,
  // isImporting,
  isDownloading,
  downloadLabel,
  downloadOpen,
  statusMessage,
  statusTone,
  editorRef,
  fileInputRef,
  downloadMenuRef,
  onToggleDownload,
  // onUploadClick,
  // onFileChange,
  onDownloadDoc,
  onDownloadPdf,
  onDismissStatus,
  onEditorChange,
  onMediaUploadStart,
  onMediaUploadComplete,
  onEditorReady,
}: BriefEditorSectionProps) {
  // const isBusy = isImporting || isDownloading;
  const isBusy = isDownloading;

  return (
    <section className={styles.briefSection}>
      <div className={styles.briefHeader}>
        <div className={styles.briefInfo}>
          <h2 className={styles.briefTitle}>Master brief</h2>
          <p className={styles.briefSubtext}>
            Press <kbd className={styles.kbdKey}>/</kbd> for blocks · upload DOC
          </p>
        </div>

        <div className={styles.headerActions}>
          {/* <input
            ref={fileInputRef}
            type="file"
            accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            className={styles.hiddenInput}
            onChange={onFileChange}
          /> */}

          {/* <button
            type="button"
            onClick={onUploadClick}
            disabled={isBusy}
            title="Upload DOC"
            className={styles.uploadButton}
          >
            {isImporting ? (
              <Loader2 size={13} className={styles.spinIcon} />
            ) : (
              <Upload size={13} />
            )}
            {isImporting ? "Importing…" : "Upload"}
          </button> */}

          <div className={styles.downloadWrapper} ref={downloadMenuRef}>
            <button
              type="button"
              onClick={onToggleDownload}
              disabled={isBusy}
              aria-expanded={downloadOpen}
              aria-haspopup="menu"
              className={styles.downloadButton}
            >
              {isDownloading ? (
                <Loader2 size={13} className={styles.spinIcon} />
              ) : (
                <Download size={13} />
              )}
              {isDownloading ? "Downloading…" : "Download"}
              {!isDownloading && (
                <ChevronDown
                  size={12}
                  className={`${styles.chevron} ${downloadOpen ? styles.open : ""}`}
                />
              )}
            </button>

            {downloadOpen && !isBusy && (
              <div role="menu" className={styles.downloadMenu}>
                <button
                  type="button"
                  role="menuitem"
                  onClick={onDownloadDoc}
                  className={styles.menuItem}
                >
                  <FileText size={14} className={styles.iconMuted} />
                  Download DOC
                </button>
                <button
                  type="button"
                  role="menuitem"
                  onClick={onDownloadPdf}
                  className={styles.menuItem}
                >
                  <FileType size={14} className={styles.iconMuted} />
                  Download PDF
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {statusMessage && (
        <div
          className={`${styles.statusBanner} ${statusTone === "err" ? styles.errTone : styles.okTone}`}
        >
          <span className={styles.statusText}>{statusMessage}</span>
          <button
            type="button"
            onClick={onDismissStatus}
            className={styles.dismissButton}
            aria-label="Dismiss"
          >
            <X size={12} />
          </button>
        </div>
      )}

      <div className={styles.editorContainer}>
        {isBusy && (
          <div className={styles.importOverlay}>
            <div className={styles.importPill}>
              <Loader2 size={15} className={styles.spinIcon} />
              {/* {isImporting ? "Importing document…" : downloadLabel} */}
              {downloadLabel}
            </div>
          </div>
        )}
        <Editor
          key={briefId}
          ref={editorRef}
          initialHtml={initialHtml}
          editable={!isBusy}
          onChange={onEditorChange}
          onMediaUploadStart={onMediaUploadStart}
          onMediaUploadComplete={onMediaUploadComplete}
          onReady={onEditorReady}
        />
      </div>
    </section>
  );
}
